import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { LoadingService } from 'src/app/_services/loading.service';
import { environment } from 'src/environments/environment';
import * as _ from 'lodash';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class PageService {

  seo_metadata = null;
  baseUrl = environment.baseUrl;
  page_form = new FormGroup({
    id: new FormControl(null),
    title : new FormControl('', [Validators.required]),
    slug: new FormControl(''),
    content: new FormControl('', [Validators.required]),
    featured_img: new FormControl(''),
  });

  constructor(private http: HttpClient,
    private loading: LoadingService,
    private datePipe: DatePipe,
  ) { }

  initializeFormGroup() {
    this.page_form.setValue({
      id: null,
      title : '',
      slug: '',
      content: '',
      featured_img: '',
    });
    this.seo_metadata = null;
  }

  populateForm(rowData: any) {
    this.seo_metadata = rowData.seo_metadata;
    this.page_form.setValue({
      id: rowData.id,
      title: rowData.title,
      slug: rowData.slug,
      content: rowData.content,
      featured_img: rowData.featured_img,
    });
  }

  get_all_pages() {
    return this.http.get(this.baseUrl + '/get_all_pages');
  }

  update_page_status(id: any, status: any) {
    return this.http.get(this.baseUrl + '/update_page_status/' + id + '/' + status);
  }

  create_page(formData: any) {
    return this.http.post(this.baseUrl + '/create_page', formData);
  }

  update_page(formData: any) {
    return this.http.post(this.baseUrl + '/update_page/' + formData.id , formData);
  }

  delete_page(pageId: any) {
    return this.http.delete(this.baseUrl + '/delete_page/' + pageId);
  }


}
